import { useQuery } from '@tanstack/react-query';
import { Lightning } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import type { ProfileResponse } from '@app/shared';
import { useT } from '../../i18n';
import { haptic } from '../../lib/tma';

/** The balance in the header; a tap opens «Кредиты». */
export function CreditsPill() {
  const t = useT();
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'], enabled: false });
  const balance = data?.user.balanceCredits ?? 0;
  return (
    <Link
      to="/credits"
      aria-label={t.shell.balance(balance)}
      onClick={() => haptic('light')}
      className="inline-flex items-center gap-1.5 h-10 px-3 rounded-full bg-surface text-fg text-sm font-bold transition-transform duration-150 active:scale-95"
    >
      <Lightning size={16} weight="fill" />
      {balance}
    </Link>
  );
}
